import { ISummaryTableProps } from "./SummaryTable";

export const View = (props: ISummaryTableProps) => {
  return (
    <section>
      <div className="summary-container">
        <table>
          <thead>
            <tr>
              <th>
                <h5>{props.Title}</h5>
              </th>
            </tr>
          </thead>
          <tbody>
            {props.data.map((val, index) => {
              return (
                <tr
                  key={index}
                  className="data-row"
                  onClick={() =>
                    val.link_url && props.navigateToRoute(val.link_url)
                  }
                >
                  {props.renderRow ? (
                    props.renderRow(val, index)
                  ) : (
                    <>
                      <td>{val.key}</td>
                      <td className="number-align--right font-ctm--semibold">
                        {" "}
                        {val.isLoading ? "..." : val.value}
                      </td>
                      <td> {">"}</td>
                    </>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </section>
  );
};
